import { render, staticRenderFns } from "./Excepciones_Supervisor_Ofertas.vue?vue&type=template&id=50768ebf"
import script from "./Excepciones_Supervisor_Ofertas.vue?vue&type=script&lang=js"
export * from "./Excepciones_Supervisor_Ofertas.vue?vue&type=script&lang=js"
import style0 from "./Excepciones_Supervisor_Ofertas.vue?vue&type=style&index=0&id=50768ebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports